export default __webpack_public_path__ + "static/media/icon-clarity.4012db91.svg";